import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom, Observable, of, queueScheduler } from 'rxjs';
import { catchError, delay, observeOn, retry, timeout } from 'rxjs/operators';
import { environment } from "../../environments/environment";
import { Contact } from '../models/message.model';

@Injectable({
    providedIn: 'root'
})
export class UserSettingsService {


    private _baseUrl = `${environment.baseUrl}`;
    private apiUrl = ''; // Your API endpoint

    constructor(private http: HttpClient) { }

    createUserSettings(userId: string, settings: any) {    
        return this.http.post(`${this._baseUrl}/users/${userId}/settings`, settings);
    }

    getUserSettings(userId: string) {
        return this.http.get(`${this._baseUrl}/users/${userId}/settings`);
    }

    updateUserSettings(userId: string, settings: any){
        return  this.http.put(`${this._baseUrl}/users/${userId}/settings`, settings);
    }
    
}